export const CREATE_MODE = 'create'

export const getLink = (slug: string) => 'https://horsesmart.store/collection/' + slug